export const Footer = () => {
  return (
    <footer>
        <p>2030 - TaskHandler</p>
    </footer>
  )
}